# --------------------------------------------------*|
#   Common.Directives.imageOnLoad
# --------------------------------------------------*|
'use strict'

angular.module("siter.io").directive "imageonload", ->
  {
    restrict: 'A'
    link: (scope, element, attrs) ->
      element.addClass 'image-load'
      element.bind 'load', ->
        element.addClass 'image-load_loaded'
        return
      return

  }



// WEBPACK FOOTER //
// ./src/app/common/directives/imageonload.coffee